import { ElMessage } from 'element-plus';

const defaults = {
  showClose: false,
};

const elMessage = (message, options = {}) => import.meta.client ? ElMessage({ ...defaults, message, ...options }) : {};

elMessage.error = (message, options = {}) => import.meta.client ? ElMessage.error({ ...defaults, message, ...options }) : () => {};

export default elMessage;
